import {lazy} from './lang.js';
import {doc} from './documentation.js';

doc(
    "range",
    {
        len: "The length of the list to be generated",
        min: "The min value to be used as the first element in the list",
        max: "The max value to be used as the last element in the list"
    },
    "Returns a list of a certain length rising from min to max"
);
export const range = (len, min=0, max=1) => {
    return (...args) => {
        let _min = lazy(min, ...args);
        let _max = lazy(max, ...args);
        let _len = lazy(len, ...args);
        return Array(len).fill(0).map(
            (x,i) => _min + i*(_max - min)/_len);
    };
};
